import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reduxStoreReducers";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

const persistConfig = {
    key: 'root',
    storage,
}

const persistedReducer = persistReducer(persistConfig, userReducer)

export const reduxStore = configureStore({
    reducer: persistedReducer,
    devTools: 'production',
    middleware: [thunk]
})

export const persistor = persistStore(reduxStore)
